export default [
  {
    title: "안전관련 서류 등",
    content: "안전보건관리책임자 선임 및 총괄 책임자 지정 등 직무교육 이수",
  },
  {
    title: "안전관련 서류 등",
    content: "안전관리자 선임 시 관할 고용노동청 선임 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "안전보건관리조직(도) 및 비상연락망 구축 등 게시",
  },
  {
    title: "안전관련 서류 등",
    content: "안전보건경영 방침(목표) 및 법령요지, 안전보건관리규정 게시",
  },
  {
    title: "안전관련 서류 등",
    content: "유해위험방지계획서 심사 후 현장관리 이행 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "밀폐공간 작업 프로그램 작성 및 허가(산소, 복합가스 측정) 관리",
  },
  {
    title: "안전관련 서류 등",
    content: "기초 안전보건교육 이수 및 취업(규칙)제한 이상 유무",
  },
  {
    title: "안전관련 서류 등",
    content: "관리감독자 지정(원/하청) 및 정기교육 실시 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "근로자 정기교육 실시 여부(분기 6Hr 이상 등)",
  },
  {
    title: "안전관련 서류 등",
    content: "특별교육(대상작업) 외 작업지휘자, 유도자, 화기취급, 기타 MSDS",
  },
  {
    title: "안전관련 서류 등",
    content: "최초 위험성평가표 작성 등 검토 여부 (공사 전 or 1개월 이내)",
  },
  {
    title: "안전관련 서류 등",
    content: "정기 위험성평가(매년 1월 정기 평가 실시) 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "수시 위험성평가 작성 및 이행·확인 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "차량계 건설기계/중량물 취급 등 운반·하역작업 계획",
  },
  {
    title: "안전관련 서류 등",
    content: "작업장 순회점검일지 작성 여부 (1회/2일_현장소장)/ TBM 일지",
  },
  {
    title: "안전관련 서류 등",
    content: "사업장 순회점검일지 작성 (안전점검일지 등_안전관리자)",
  },
  {
    title: "안전관련 서류 등",
    content: "유해·위험기계, 기구 및 작업, 안전점검표 작성 여부",
  },
  {
    title: "안전관련 서류 등",
    content: "안전보건협의체 및 산업안전보건위원회 or 노사협의체 운영",
  },
  {
    title: "안전관련 서류 등",
    content: "합동안전보건점검 실시 여부 (1회/2월)",
  },
  {
    title: "안전관련 서류 등",
    content: "산업안전보건관리비 계획 및 사용관리(보호구 지급/수·불대장)",
  },
  {
    title: "안전관련 서류 등",
    content: "건설 재해예방 기술지도 시 조치사항 관리",
  },
  {
    title: "현장",
    content: "현장 정리정돈 및 근로자 안전통로 확보",
  },
  {
    title: "현장",
    content: "굴착면 등 사면 붕괴위험 방지 여부",
  },
  {
    title: "현장",
    content: "유해·위험 구간 안전·보건표지 게시",
  },
  {
    title: "추락·낙하",
    content: "고소작업 시 안전대부착설비 및 안전대 착용 여부",
  },
  {
    title: "추락·낙하",
    content: "사다리(2인 1조, 아웃트리거, 최상단 작업금지) 안전작업 여부",
  },
  {
    title: "추락·낙하",
    content: "슬라브 단부, 개구부(덮개), 철골 등 안전난간대 설치 여부",
  },
  {
    title: "추락·낙하",
    content: "비계 설치(안전난간,작업발판,연결부,베이스,벽이음재 등) 상태",
  },
  {
    title: "추락·낙하",
    content: "추락 or 낙하물방지망(내부 쪽망 등) 설치",
  },
  {
    title: "추락·낙하",
    content: "주출입구 방호선반 설치 여부(수평 돌출 길이 2m 이상)",
  },
  {
    title: "건설장비",
    content: "건설장비 아웃트리거 설치 및 지반상태",
  },
  {
    title: "건설장비",
    content: "달줄/달기구 이상유무 (손상,부식,소선 끊어짐)",
  },
  {
    title: "건설장비",
    content: "굴삭기 버킷 안전핀 및 지게차 후방감시카메라 등 안전밸트",
  },
  {
    title: "건설장비",
    content: "전담유도(신호)자 배치관리 여부",
  },
  {
    title: "감전",
    content: "용접기 안전사용 여부 (자동전격방지장치, 충전부 절연 방호)",
  },
  {
    title: "감전",
    content: "둥근톱/그라인더 안전 덮개, 각종 안전장치 등",
  },
  {
    title: "감전",
    content: "작업 전선 접지/피복 외 정리상태 / 고압전선 방호관 설치",
  },
  {
    title: "감전",
    content: "분전반(시건,관리자 명기,접지,접촉 방지판,물기 이격 등) 관리",
  },
  {
    title: "화재",
    content: "소화기 및 임시소방시설 비치 여부 (비상대피로 부착 등)",
  },
  {
    title: "화재",
    content: "화재감시자 배치(지하층 용접, 용단 외 11m 이내 가연성물질)",
  },
  {
    title: "화재",
    content: "위험물저장소의 운영(안전캡, 소화기, MSDS, 정부관리자 표기)",
  },
  {
    title: "건강관리",
    content: "신규채용시 근로자 혈압체크(기준 150/90mmHg) 등 건강문진",
  },
  {
    title: "건강관리",
    content: "일반건강진단 1회/1년 실시 등",
  },
  {
    title: "건강관리",
    content: "특수/배치전 건강진단 실시 및 요관찰자 이상 관리",
  },
  {
    title: "건강관리",
    content: "건강관리 용품, 장구류 및 응급·구호물품 관리 여부",
  },
  {
    title: "점검",
    content: "작업환경측정 실시 여부 (착공 후 한달/ 그후 6개월 주기)",
  },
  {
    title: "점검",
    content: "사무실, 교육장 등 현장 게시(작업환경측정 결과,MSDS,경고표지)",
  },
  {
    title: "점검",
    content: "중량물 취급주의 포스터 부착 (5Kg 이상)",
  },
  {
    title: "점검",
    content: "비산먼지 방지 등 소음 저감 시설 등",
  },
  {
    title: "휴게",
    content: "총 공사금액 20억 이상 근로자 휴게시설(더위/추위 쉼터), 기타, 편의시설 운영(화장실, 탈의실, 샤워실 설치)",
  },
];
